import { render, staticRenderFns } from "./PaymentBancolombia.vue?vue&type=template&id=cfb46680"
import script from "./PaymentBancolombia.vue?vue&type=script&lang=js"
export * from "./PaymentBancolombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports